import { IsJsonString } from 'utils';

import config from 'config';

const API_URL = config.REACT_APP_API_URL;

const createProjectUpdatesWithLoading = (formdata, onProgress) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    const url = `${API_URL}updates`;

    xhr.open('POST', url);

    const user = JSON.parse(localStorage.getItem('user'));

    if (user && user.uid) {
      xhr.setRequestHeader(
        'access-token',
        localStorage.getItem('access-token')
      );

      xhr.setRequestHeader('client', localStorage.getItem('client'));

      xhr.setRequestHeader('uid', localStorage.getItem('uid'));
    }

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        const percent = Math.round((event.loaded / event.total) * 100);

        onProgress(percent);
      }
    };

    xhr.onload = () => {
      if (xhr.getResponseHeader('client')) {
        localStorage.setItem('client', xhr.getResponseHeader('client'));
      }

      if (xhr.getResponseHeader('access-token')) {
        localStorage.setItem(
          'access-token',

          xhr.getResponseHeader('access-token')
        );
      }

      if (xhr.getResponseHeader('uid')) {
        localStorage.setItem('uid', xhr.getResponseHeader('uid'));
      }

      const text = xhr.responseText;

      const data = text && IsJsonString(text) ? JSON.parse(text) : text;

      if (xhr.status < 200 || xhr.status >= 300) {
        let error;

        switch (xhr.status) {
          case 401:
            error = data.errors;


            break;

          case 400:
            error = data.errors || xhr.statusText;

            break;

          case 422:
            error =
              data.errors?.full_messages ||
              data.errors ||
              data.error ||
              xhr.statusText;

            break;

          case 403:
            error = data.errors || xhr.statusText;

            break;

          case 500:
            error = { full_messages: ['Internal Server Error'] };

            break;

          default:
            error = data.errors || xhr.statusText;

            break;
        }

        reject({ errors: error });

        return;
      }

      if (!IsJsonString(text) && data.startsWith && data.startsWith('error')) {
        reject({ errors: data });

        return;
      }

      resolve({
        update: data || xhr,
      });
    };

    xhr.onerror = () => {
      reject({
        errors: ['Please check your internet connection!'],
      });
    };

    xhr.send(formdata);
  });
};

export default createProjectUpdatesWithLoading;
